import React from 'react';

export const Cell25 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 87 87"
      {...props}
    >
      <defs>
        <clipPath id="cell25-path">
          <circle cx="43.5" cy="149.17" r="36.5" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#cell25-path)">
        <path
          strokeMiterlimit="10"
          fill="#27375f"
          stroke="#fff"
          opacity=".31"
          d="M-6.92 83.93h102v58h-102z"
        />
      </g>
      <circle cx="43.5" cy="43.5" r="43.5" fill="#fff" />
      <path
        strokeMiterlimit="10"
        fill="#fff"
        stroke="#27375f"
        strokeWidth="1.14px"
        d="M48.61 34.65H38.39l-5.11 8.85 5.11 8.85h10.22l5.11-8.85-5.11-8.85zM48.61 52.35H38.39l-5.11 8.86 5.11 8.85h10.22l5.11-8.85-5.11-8.86zM48.61 16.94H38.39l-5.11 8.85 5.11 8.86h10.22l5.11-8.86-5.11-8.85z"
      />
    </svg>
  );
};
